/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ThemeKeysEnum {
  PrimaryMainColorCount = 'PrimaryMainColorCount',
  Primary50 = 'Primary50',
  Primary100 = 'Primary100',
  Primary200 = 'Primary200',
  Primary300 = 'Primary300',
  Primary400 = 'Primary400',
  Primary500 = 'Primary500',
  Primary600 = 'Primary600',
  Primary700 = 'Primary700',
  Primary800 = 'Primary800',
  Primary900 = 'Primary900',
  Primary950 = 'Primary950',
  SecondaryMainColorCount = 'SecondaryMainColorCount',
  Secondary50 = 'Secondary50',
  Secondary100 = 'Secondary100',
  Secondary200 = 'Secondary200',
  Secondary300 = 'Secondary300',
  Secondary400 = 'Secondary400',
  Secondary500 = 'Secondary500',
  Secondary600 = 'Secondary600',
  Secondary700 = 'Secondary700',
  Secondary800 = 'Secondary800',
  Secondary900 = 'Secondary900',
  Secondary950 = 'Secondary950',
  DefaultFontFamily = 'DefaultFontFamily',
  DefaultFontSize = 'DefaultFontSize',
  DefaultFontWeight = 'DefaultFontWeight',
  DefaultFontColor = 'DefaultFontColor',
  ItemBg = 'ItemBg',
  ItemBorderColor = 'ItemBorderColor',
  ItemBorderStyle = 'ItemBorderStyle',
  ItemBorderWidth = 'ItemBorderWidth',
  ItemBorderRadius = 'ItemBorderRadius',
  ItemTitleFontFamily = 'ItemTitleFontFamily',
  ItemTitleFontSize = 'ItemTitleFontSize',
  ItemTitleFontWeight = 'ItemTitleFontWeight',
  ItemTitleFontColor = 'ItemTitleFontColor',
  ItemDescriptionFontFamily = 'ItemDescriptionFontFamily',
  ItemDescriptionFontSize = 'ItemDescriptionFontSize',
  ItemDescriptionFontWeight = 'ItemDescriptionFontWeight',
  ItemDescriptionFontColor = 'ItemDescriptionFontColor',
  ItemPriceFontFamily = 'ItemPriceFontFamily',
  ItemPriceFontSize = 'ItemPriceFontSize',
  ItemPriceFontWeight = 'ItemPriceFontWeight',
  ItemPriceFontColor = 'ItemPriceFontColor',
  ItemAmountFontFamily = 'ItemAmountFontFamily',
  ItemAmountFontSize = 'ItemAmountFontSize',
  ItemAmountFontWeight = 'ItemAmountFontWeight',
  ItemAmountFontColor = 'ItemAmountFontColor',
  SectionSeperatorColor = 'SectionSeperatorColor',
  SectionTitleFontFamily = 'SectionTitleFontFamily',
  SectionTitleFontSize = 'SectionTitleFontSize',
  SectionTitleFontWeight = 'SectionTitleFontWeight',
  SectionTitleFontColor = 'SectionTitleFontColor',
  MenuBg = 'MenuBg',
  MenuBgAlt = 'MenuBgAlt',
  ChangingBgEnabled = 'ChangingBgEnabled',
  MenuTitleFontFamily = 'MenuTitleFontFamily',
  MenuTitleFontSize = 'MenuTitleFontSize',
  MenuTitleFontWeight = 'MenuTitleFontWeight',
  MenuTitleFontColor = 'MenuTitleFontColor',
  ControlFontFamily = 'ControlFontFamily',
  ControlFontSize = 'ControlFontSize',
  ControlFontWeight = 'ControlFontWeight',
  ControlFontColor = 'ControlFontColor',
  ControlBg = 'ControlBg',
  ControlBgHover = 'ControlBgHover',
  ControlBgLight = 'ControlBgLight',
  ControlBgDark = 'ControlBgDark',
  ControlDisabled = 'ControlDisabled',
  ControlHero = 'ControlHero',
  ControlHeroHover = 'ControlHeroHover',
  ControlBorderColor = 'ControlBorderColor',
  ControlBorderStyle = 'ControlBorderStyle',
  ControlBorderWidth = 'ControlBorderWidth',
  ControlBorderRadius = 'ControlBorderRadius',
  QrCodeBgDark = 'QrCodeBgDark',
  QrCodeBgLight = 'QrCodeBgLight'
}
